/* eslint-disable */
/**
 * Event Emitter bus/class
 */
class EventEmitter {
  constructor(events) {
    this.events = events || {}
  }

  // subscribe to event with handler
  on(name, cb) {
    ;(this.events[name] || (this.events[name] = [])).push(cb)

    // unsubscribe event handler
    return {
      off: () =>
        this.events[name] &&
        this.events[name].splice(this.events[name].indexOf(cb) >>> 0, 1),
    }
  }

  // emit event
  emit(name, ...args) {
    ;(this.events[name] || []).forEach((fn) => fn(...args))
  }
}

export const Emitter = new EventEmitter()
